document.addEventListener('DOMContentLoaded', function () {
  // Riferimento all'offcanvas
  const offcanvasElement = document.getElementById('navbarNavOffcanvasMain');

  // Riferimenti alle icone
  const menuIcon = document.querySelector('.menu-icon');
  const closeIcon = document.querySelector('.close-icon');

  if (offcanvasElement && menuIcon && closeIcon) {
    // Impostazione stato iniziale
    menuIcon.style.opacity = '1';
    menuIcon.style.visibility = 'visible';
    closeIcon.style.opacity = '0';
    closeIcon.style.visibility = 'hidden';

    // Evento quando l'offcanvas viene aperto
    offcanvasElement.addEventListener('shown.bs.offcanvas', function () {
      menuIcon.style.opacity = '0';
      menuIcon.style.visibility = 'hidden';
      closeIcon.style.opacity = '1';
      closeIcon.style.visibility = 'visible';
    });

    // Evento quando l'offcanvas viene chiuso
    offcanvasElement.addEventListener('hidden.bs.offcanvas', function () {
      menuIcon.style.opacity = '1';
      menuIcon.style.visibility = 'visible';
      closeIcon.style.opacity = '0';
      closeIcon.style.visibility = 'hidden';
    });
  }
});


jQuery(function () {
  var lightbox = new PhotoSwipeLightbox({
    gallery: '.photo-grid',
    children: 'a',
    showHideAnimationType: 'fade',
    zoomAnimationDuration: false,
    pswpModule: PhotoSwipe
  });
  lightbox.init();

  if(jQuery('.swiper-card').length){
    var swiper = new Swiper(".swiper-card", {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 20,
        pagination: {
            el: ".swiper-pagination"
        },
        navigation: false,
        scrollbar: false,
        autoplay: {
            delay: 15000,
        },
        breakpoints: {
            320: {
                slidesPerView: "auto",
                spaceBetween: 10,
            },
            768: {
              slidesPerView: "auto", 
              spaceBetween: 10,
            },
            992: {
                slidesPerView: 2, 
                spaceBetween: 20,
            }

        }
    });
}

  jQuery('.btn-consent').on('click', function (e) {
    jQuery.cookie('consent', '1', { expires: 30, path: '/' });
    jQuery('#modal-command-consent').modal('hide');
  });

  jQuery('.btn-preferenze').on('click', function () {
    // modal-dialog-preferenze
    var info = jQuery('.modal-dialog-info');
    var pref = jQuery('.modal-dialog-preferenze');
    info.hide();
    pref.show();
  });

  jQuery('.btn-preferenze-back').on('click', function () {
    // modal-dialog-preferenze
    var info = jQuery('.modal-dialog-info');
    var pref = jQuery('.modal-dialog-preferenze');
    info.show();
    pref.hide();
  });
  
});

jQuery(window).on('load', function () {
  var cookieCookie = jQuery.cookie('consent');
  if (!cookieCookie) {
    setTimeout(function () {
      jQuery('#modal-command-consent').modal('show');
    }, 5000);
  }
});


